<script>
import axios from "axios";
import appConfig from "@/app.config";
import { countriesMethods, countriesComputed } from "@/state/helpers";
export default {
  page: {
    title: "Register ",
    meta: [{ name: "description", content: appConfig.description,  },],
  },
  data() {
    return {
      today: new Date().toLocaleDateString('fr-CA'),
      dob:new Date().toLocaleDateString('fr-CA'),
      nationality:"",
      fullname:"",
      gender:"Male",
      telephone:"",
      email: "",
      password: "",
      error:'',
      loader:false,
    };
  },
  methods: {
    ...countriesMethods,
    async register() { 
      this.loader=true;
      let formData = new FormData();
      formData.append("email", this.email);
      formData.append("gender", this.gender);
      formData.append("telephone", this.telephone);
      formData.append("dob", this.dob);
      formData.append("nationality", this.nationality);
      formData.append("fullname", this.fullname);
      let url = "/clientregister";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.$router.push({name: "login",})       
        } else {
          this.error=response.data.message;
        }
      })
      }
    },
    computed: {
    ...countriesComputed,
    },
    created() {
      this.fetchCountries();
    },
};
</script>

<template>
  <div class="container-fluid bg-primary p-5" >
    <div class="row">
      <div class="col-md-6 mx-auto">
        <div class="card shadow-lg">
          <div class="card-body">
            <img src="@/assets/images/logo.png" height="50px" />
            <br><br>
            <span class="mt-4 ms-2 text-black h4"> Create your account to continue</span>
          <div v-if="error" class="bg-danger text-white p-1 mt-2" style="font-size:12px">{{ error }}</div >
          <div class="mt-1">
            <b-form class="row p-2" @submit.prevent="register">
                <b-form-group class="col-md-6 mb-3 text-black" id="input-group-1" label="Full Name" label-for="input-1" >
                <b-form-input id="input-1" v-model="fullname" type="text" placeholder="Enter Full Name"></b-form-input>
                </b-form-group>
                <div class="col-md-6 mb-1 text-black"><label>Gender</label>
                <select class="form-control" v-model="gender"><option>Female</option><option>Male</option></select>
                </div>
                <b-form-group class="col-md-6 mb-1 text-black" label="Telephone">
                <b-form-input v-model="telephone" type="number" placeholder="Enter Telephone"></b-form-input>
                </b-form-group>
                <b-form-group class="col-md-6 mb-1" label="Date of Birth">
                <b-form-input v-model="dob" type="date" :max="today" placeholder="Enter Date of Birth"></b-form-input>
                </b-form-group>
                <b-form-group class="col-md-6 mb-1 text-black" label="Nationality">
                <v-select :options="countries" placeholder="Enter Nationality" v-model="nationality" label="name" :reduce="nationality => nationality.name"></v-select>
                </b-form-group>
                <b-form-group class="col-md-6 mb-1 text-black" id="input-group-1" label="Email Address" label-for="input-1" >
                <b-form-input id="input-1" v-model="email" type="email" placeholder="Enter Email Address"></b-form-input>
              </b-form-group>
              <div class="my-3 d-grid">
              <b-button type="submit" variant="primary">Register <b-spinner v-if="loader" small class="mr-1" label="Small Spinner"/></b-button>
              </div>
              <div class="bg-danger p-1 rounded-1 text-white text-center" style="font-family:Arial;">
                Your ONE TIME PASSWORD will be sent to the email address you provide here.
              </div>
             <div class="ms-2 mt-4"><router-link to="/login" class="text-black"><i class="fas fa-unlock"></i> Login Now</router-link></div>
            </b-form>
          </div>
        </div>
        </div>
      </div>
    </div>
    <div class="mb-2">.</div>
  </div>
</template>